import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   plans:{
      parcelUnlock:{
         key:'parcelUnlock',
         price:9,
         period:null,
         type:'charge',
         ga:{
            value:9,
            currency: "USD",
            items:[
               {
                  item_id: "parcel_unlock",                  
                  item_name: "Parcel Unlock",
                  quantity: 1,
                  price: 9
               }
            ]
         }
      },
      dayPass:{
         key:'dayPass',
         price:24,
         period:null,
         type:'subscription',
         ga:{
            value:24,
            currency: "USD",
            items:[
               {
                  item_id: "day_pass",
                  item_name: "Day Pass",
                  quantity: 1,
                  price: 24
               }
            ]
         }
      },
      studio:{
         key:'studio',
         price:99,
         period:'month',
         type:'subscription',
         ga:{
            value:99,
            currency: "USD",
            items:[
               {
                  item_id: "studio_subscription",
                  item_name: "Studio Subscription",
                  quantity: 1,
                  price: 99
               }
            ]            
         }
      }
   },
   current:null,
   active:false,
   loaded:false
};

// getters
const getters = {
};

// actions
const actions = {
   PLAN_CLEAR:(context)=>{
      context.commit('PLAN_CLEAR');
   },
   PLAN_CURRENT:(context)=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/subscriptions?status=active')
         .then((res)=>{

            if (!res || !res.data || res.data.length < 1){
               context.commit('PLAN_LOADED_SET', true);
               return resolve();
            }

            let activeTs, activePlan;
            for (let i=0,len=res.data.length;i<len;i++){
               let subscription = res.data[i];
               if (subscription.recurring){
                  context.commit('PLAN_CURRENT_SET', subscription);
                  context.commit('PLAN_LOADED_SET', true);
                  return resolve();
               }
               let createdTs = new Date(subscription.created).getTime();

               if (!activeTs || createdTs > activeTs){
                  activeTs = createdTs;
                  activePlan = subscription;
               }
            }

            context.commit('PLAN_CURRENT_SET', activePlan);
            context.commit('PLAN_LOADED_SET', true);

            resolve();
         })
         .catch((error)=>{
            // sniff for certain status codes
            switch(error.response.status){
               // unauthorized, the user is logged out
               case (401): 
                  context.commit('PLAN_LOADED_SET', true);
                  return resolve();
               case (404): 
                  context.commit('PLAN_LOADED_SET', true);
                  return resolve();
               case (406): 
                  context.commit('PLAN_LOADED_SET', true);
                  return resolve();
            }

            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('subscription plan',error)});

            reject(error);
         });
      });
   },
   PLAN_ACTIVE_CHECK:(context)=>{
      context.commit('PLAN_ACTIVE_CHECK');
   }
};

// mutations
const mutations = {
   PLAN_CLEAR:(state,plan)=>{
      state.current = null;
      state.active = false;
   },
   PLAN_CURRENT_SET:(state,plan)=>{
      state.current = plan;
   },
   PLAN_LOADED_SET:(state,loaded)=>{
      state.loaded = loaded;
   },
   PLAN_ACTIVE_CHECK:(state,plan)=>{
      if (!state.current){
         state.active = false;
         return;
      }
      let current = state.current;
      if (current.plan.recurring){
         state.active = true;
         return;
      }
      const nowTs = new Date().getTime();
      const currentPlanTs = new Date(current.created).getTime();
      const dayTs = 24*60*60*1000;

      if (nowTs <= currentPlanTs+dayTs){
         state.active = true;
         return;
      }
      state.active = false;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/plan.js